import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const buildkitePlugin = createPlugin({
  id: 'buildkite',
  routes: {
    root: rootRouteRef,
  },
});

export const GetArtifactPage = buildkitePlugin.provide(
  createRoutableExtension({
    component: () =>
      import('./components/GetArtifact').then(m => m.GetArtifact),
    mountPoint: rootRouteRef,
  }),
);

export const BuildkitePage = buildkitePlugin.provide(
  createRoutableExtension({
    component: () =>
      import('./components/BuildkitePage').then(m => m.BuildkitePage),
    mountPoint: rootRouteRef,
  }),
);
